// extracted by mini-css-extract-plugin
export default {"QuestionLabelContent":"_5bf_qABeZRW62oMirPUL","QuestionLabel":"CGUt2G0WYyu_NxnCsmh1","QuestionSubLabel":"_5ZtKlX2qg2cijkXZw4A","HightlightText":"U2hYgW6UUUTRxazP0TeS"};